import React, { Component } from 'react'
import DoubleSliderPlaceholder from './DoubleSliderPlaceholder'
import PropTypes from 'prop-types'
import ReactPlaceholder from 'react-placeholder'
import { AdSlider } from '../'

import 'react-placeholder/lib/reactPlaceholder.css'

import '@loyal_molecules/slider.css'
import '@loyal_template/showcases.css'

class DoubleSlider extends Component {
  render () {
    return (
      <ReactPlaceholder ready customPlaceholder={<DoubleSliderPlaceholder />}>
        <div className='container-slider pos-relative bg-ui-3'>
          <div className='row align-items-center h-100 '>
            <div className='container'>
              <div className='row align-items-center h-100 txt-center'>
                {this.props.targeting.map((itemSlider, index) => (
                  <div key={index} className='col-6 slider-item'>
                    <AdSlider
                      accountDfp={itemSlider.accountDfp}
                      sliderName={itemSlider.sliderName}
                      slotSize={itemSlider.slotSize}
                      targeting={itemSlider.targeting}
                      collapseEmptyDivs
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </ReactPlaceholder>
    )
  }
}
DoubleSlider.propTypes = {
  targeting: PropTypes.array
}

export default DoubleSlider



// WEBPACK FOOTER //
// ./src/features/Slider/doubleSlider/DoubleSlider.js